import { useToastNotificationContext } from './useToastNotification';

import AlertWithTriggerComponent from '../../../components/common/ToastNotification/alertWithTrigger';
import ConfirmationModaltWithTrigger from '../../../components/common/ToastNotification/confirmationModalWithTrigger';
import ErrorToastComponent from '../../../components/common/ToastNotification/errorToastWithTrigger';
import ToastAlert from '../../../components/common/ToastNotification/toastAlert';

const ToastNotification = () => {
  const {
    toast,
    removeToastHandler,
    alertModal,
    closeAlertModal,
    errorToast,
    closeErrorToast,
    openSubmitErrorTicket,
    confirmationModal,
    closeConfirmationModal,
    callConfirmationTrigger,
  } = useToastNotificationContext();

  return (
    <>
      {toast.open && (
        <ToastAlert
          open={toast.open}
          setOpen={removeToastHandler}
          message={toast.message}
          severity={toast.severity}
          duration={errorToast?.open ? 1000 : 2500} // check if errorToast will show to avoid showing ToastAlert
        />
      )}
      {alertModal.open && (
        <AlertWithTriggerComponent
          open={alertModal.open}
          handleClose={closeAlertModal}
          headerText={alertModal.headerText}
          alertText={alertModal.alertText}
        />
      )}
      {errorToast?.open && !toast.open && (
        <ErrorToastComponent
          open={errorToast.open}
          handleClose={closeErrorToast}
          alertText={errorToast.message}
          submitError={openSubmitErrorTicket}
        />
      )}

      {confirmationModal.open && (
        <ConfirmationModaltWithTrigger
          open={confirmationModal.open}
          callTrigger={callConfirmationTrigger}
          handleClose={closeConfirmationModal}
          headerText={confirmationModal.headerText}
          alertText={confirmationModal.alertText}
          buttonText1={confirmationModal.buttonText1}
          buttonText2={confirmationModal.buttonText2}
        />
      )}
    </>
  );
};

export default ToastNotification;